import React from 'react'
import MyBookings from '../components/MyBookings'

function BookingPage() {
    return (
        <div className="container mx-auto p-4 lg:p-8 py-12">
            <MyBookings />
        </div>
    )
}

export default BookingPage